//个人优势模板
var advantage = [
  {
    label: "个体创业者",
    text:
      "踏实肯干，不畏艰难，能吃苦能抗压. 我相信：身份就是一张白纸，取胜与否在于心态。"
  },
  {
    label: "应届毕业生",
    text:
      "沟通协调能力强，善于团队合作。 大学四年的工作经历能够证明我这一点，尤其是学生会和社团的工作经历，我善于听取他人意见，并有自己的主观判断，具有与团结合作协调能力。"
  },
  {
    label: "销售经理",
    text:
      "坚持不懈、自立自强 。在几年的工作经历中与不同事物打交道，锻炼了自己的胆量，学会了一定的销售技巧并分辨不同布料的能力。我的人生信念：方向比努力更重要！办法永远比困难多！路是走出来的，没有克服不了的困难。"
  },
  {
    label: "客服经理",
    text:
      "从事了2年的客服行业，曾管理50人客服团队。团队战斗力得到了公司各层领导的肯定和支持，也得到了认可。口齿伶俐、思维灵敏、管理组织能力强，精通各种客服话术技巧。"
  },
  {
    label: "人事经理",
    text:
      "5年工作经验，了解基础人事工作和财务相关知识。性格特点：细心并耐心，心地善良、乐于助人，愿意靠实力说话，相信女人也会有自己的事业。"
  },
  {
    label: "行政专员",
    text:
      "从事行政行业2年，有自己的心得和工作方法，工作效率极高，得到前公司老板们的一致认可。工作上交给我的事儿从来没有纰漏，具备及时并准确接听/转接电话和处理问题。个人特点：亲和力强，执行力强，善于沟通，细心，责任心强，品性好"
  },
  {
    label: "财务经理",
    text:
      "本科学历，与10年毕业，从事财务行业以后6年。个人特点：思维敏捷，接受能立强，能够独立思考，善于总结工作经验。能够熟练应用财务及office办公软件，对金蝶、用友等财务系统有实际操作经验。"
  }
];

//工作经历模板
var experienceEdit = [
  {
    label: "行政文员",
    text:
      "1、负责公司内部日常行政事务，包括规章制度的制定、监督、执行；\n2、负责公司内部公文处理、各种证件的办理与年检；\n3、完成领导交办的其他工作；\n4、协助其他部门的沟通工作；"
  },
  {
    label: "财务经理",
    text:
      "1、审批财务收支，审阅财务专题报告和会计报表；\n2、编制预算和执行预算，参与拟订资金筹措和使用方案；\n3、审查公司对外提供的会计资料；\n4、组织编制与实现公司的财务收支计划、信贷计划与成本费用计划。"
  },
  {
    label: "出纳",
    text:
      "1、负责日常收支的管理和核对；\n2、办公室基本账务的核对；\n3、负责收集和审核原始凭证，保证报销手续及原始单据的合法性、准确性；\n4、负责登记现金、银行存款日记账并准确录入系统，按时编制银行存款余额调节表；\n5、负责记账凭证的编号、装订；保存、归档财务相关资料；\n6、负责开具各项票据；\n7、配合总会负责办公室财务管理统计汇总。"
  },
  {
    label: "商务顾问",
    text:
      "1. 负责公司企业会员、互联网产品的新老客户开发与维护，完成公司下达的任务；\n2. 通过各种媒介，寻找潜在客户及维护长期客户，及时准确地了解客户信息，把握客户需求，共同制订客户跟进方案；\n3. 跟进潜在客户，为客户现场提供专业的产品演示和解决方案，积极提升客户体验；\n4. 有效进行客户关系的维护和发展，提升客户满意度和客户价值，建立长期共赢的客户合作关系；"
  },
  {
    label: "渠道销售",
    text:
      "1、销售人员职位，在上级的领导和监督下定期完成量化的工作要求，并能独立处理和解决所负责的任务；\n2、管理客户关系，完成销售任务；\n3、了解和发掘客户需求及购买愿望，介绍自己产品的优点和特色；\n4、对客户提供专业的咨询；\n5、收集潜在客户资料；\n6、收取应收帐款。"
  },
  {
    label: "客服文员",
    text:
      "1.为客户准确提供运费咨询、取件安排、快件查询等服务；\n2.高效率处理问题件，积极回应客户表扬、建议及投诉；\n3.准确及时记录并转达客户需求，必要时和其他部门协作为客户提供服务；\n4.积极推广公司的产品和服务，解答相关问题，以实现客户满意度和收益的最大化；"
  },
  {
    label: "客服",
    text:
      "1、根据公司提供的客户电话，向客户解释本公司的产品及服务； \n2、负责接听客户热线，为客户讲解、推广产品；\n3、通过电话负责客户的约访工作；"
  },
  {
    label: "导购员",
    text:
      "1、接待顾客的咨询，了解顾客的需求并达成销售； \n2、完成商品的来货验收、上架陈列摆放等；\n3、完成上级领导交办的其他任务。"
  },
  {
    label: "物业管理",
    text:
      "1、负责商业项目物业管理事物（办公区域、公司设备巡查、装修检查、内部文书写作派发等）；\n2、负责处理顾客纠纷投诉；\n3、负责顾客咨询、答疑、接待；\n4、协助处理商城其他事务。"
  },
  {
    label: "人事经理",
    text:
      "1、负责薪资核算，社会保险、商业保险办理等薪酬基本业务的操作；\n2、负责成本预算、薪酬数据分析及统计，并提供相应报表；\n3、解决日常的薪酬福利问题，并提供支持和建议；\n4、协助制定、完善公司薪资管理制度；\n5、调查了解各地区薪资政策和薪资水平，为公司决策提供依据。"
  }
];

//项目经历模板
var project = [
  {
    label: "金融",
    text:
      "1、该项目完全依赖于互联网进行运营，服务范围极广，包括基本电子支票业务、利息支票业务、货币市场、基本储蓄业务、信用卡及CDS等大范围的多种银行服务；\n2、该项目每年营业365天，每天营业24小时，通过电子邮件或免费热线，为客户提供充满活力的、全天候的客户服务支持；\n3、该项目主要的模式是为消费者提供多家合作保险公司的产品报价，帮助消费者做出购买决定；为代理人提供消费者的个人信息和投保意向；\n4、简化了保险产品流通环节它把大量的客户介绍给保险公司的同时也把最好的保险公司和险种介绍给客户，通过互联网把保险公司和客户联结在一起，为保险公司和客户同时带来了显著的利益；"
  },
  {
    label: "IT",
    text:
      "1、该项目的主要实现目标是考核系统中的用户角色模块的增删改查以及给用户指定角色，给角色指定相应的模块和用户登录的权限控制。带领团队5人历时两个月完成了对该项目的开发完成； \n2、 该考核系统使用Strusl.X + Hibernate + Spring + Ajax + Velocity技术， 采用多层开发方式优化大数据的统计和查询分析， 对现有记事本数据批量快速导入SQL Server并结合Excel pdf编程技术对系统开发实现；\n3、 最终还实现了在考核系统中有统计有效卡、 到期卡、 考核日均存款、 员工消费、 分析卡效益等。"
  }
];

module.exports = {
  advantage: advantage,
  experienceEdit: experienceEdit,
  project: project
};
